export default __webpack_public_path__ + "static/media/icon-info.28467c53.svg";